import * as ACTIONS from '../constants';

export function getMailbox(payload)
{
    //console.log("Get Action")
    //console.log(payload);
    return {
        type: ACTIONS.MAILBOX_GET,
        payload
    }
}

export function updateMailbox(payload)
{

    //console.log("Action")
    //console.log(payload)

    return {
        type: ACTIONS.MAILBOX_GET_UPDATE,
        payload
    }
}

export function updateMailboxInvite(payload)
{
    return {
        type: ACTIONS.MAILBOX_UPDATE_INVITE,
        payload
    }
}